import styles from "@/styles/multiSelectSearch.module.css";

// Search-header pt keys shared by every searchable pill MultiSelect. Spread
// into each consumer's own pt object alongside its pill/panel/item classes.
export const multiSelectSearchPt = {
  closeButton: { className: styles.closeButton },
  filterIcon: { className: styles.filterIcon },
  // MultiSelect forwards this whole object as InputText's own `pt` prop,
  // and InputText looks up its className via `pt.root`, not the top level.
  filterInput: { root: { className: styles.filterInput } },
  headerCheckboxContainer: { className: styles.headerCheckboxContainer },
};
